import type { AnamnesisTemplate } from './types';

export const ADOLESCENTE_TEMPLATE: AnamnesisTemplate = {
    id: 'adolescente',
    name: 'Anamnese adolescente',
    sections: [
        {
            title: 'Identificação',
            questions: [
                'Escola/ocupação atual?',
                'Com quem mora?',
                'Quem participou do primeiro contato?',
            ],
        },
        {
            title: 'Queixa e demanda',
            questions: [
                'A demanda partiu do adolescente ou dos responsáveis?',
                'O que cada um percebe como problema?',
                'Quando as dificuldades começaram?',
            ],
        },
        {
            title: 'História da queixa atual',
            questions: [
                'Como a situação evoluiu?',
                'Em quais contextos aparece (casa, escola, amigos)?',
                'O que já ajudou ou piorou?',
            ],
        },
        {
            title: 'Saúde e histórico médico',
            questions: [
                'Condições de saúde e medicações em uso?',
                'Uso de álcool ou outras substâncias?',
                'Já houve autolesão ou pensamentos de morte? (abordar com cuidado)',
                'Tratamentos anteriores?',
            ],
        },
        {
            title: 'Vida escolar',
            questions: [
                'Como está o desempenho e a frequência?',
                'Como é a relação com a escola e os professores?',
                'Há planos para o futuro (estudos, trabalho)?',
            ],
        },
        {
            title: 'Família',
            questions: [
                'Como é a relação com os responsáveis?',
                'Como a família se comunica e resolve conflitos?',
                'Houve mudanças recentes na família?',
            ],
        },
        {
            title: 'Vida social e relacionamentos',
            questions: [
                'Como são as amizades?',
                'Há relacionamentos afetivos?',
                'Como é o uso de redes sociais e jogos?',
            ],
        },
        {
            title: 'Sono, alimentação e rotina',
            questions: [
                'Horários de dormir e acordar?',
                'Como está a alimentação e a relação com o corpo?',
                'O que faz no tempo livre?',
            ],
        },
        {
            title: 'Identidade e projeto de vida',
            questions: [
                'Como se descreve?',
                'O que gosta em si e o que gostaria de mudar?',
                'Quais são os planos e sonhos?',
            ],
        },
        {
            title: 'Expectativas',
            questions: ['O que o adolescente espera dos encontros?', 'E os responsáveis?'],
        },
    ],
};
